import React, { useState, useEffect } from 'react';
import logo from '../assets/image.png';

export default function Loader({ isLoading }) {
  const [shouldRender, setShouldRender] = useState(isLoading);
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    if (isLoading) {
      setShouldRender(true);
      setFadeOut(false);
    } else {
      setFadeOut(true);
      const timer = setTimeout(() => {
        setShouldRender(false);
      }, 700); // match duration of fade animation
      return () => clearTimeout(timer);
    }
  }, [isLoading]);

  if (!shouldRender) return null;

  return (
    <div
      className={`fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-[#faf8f5] transition-opacity duration-700 ease-out ${
        fadeOut ? 'opacity-0 pointer-events-none' : 'opacity-100'
      }`}
    >
      {/* Background Soft Glow */}
      <div className="absolute w-72 h-72 bg-[#c39b5b]/10 rounded-full blur-3xl animate-pulse pointer-events-none" />

      {/* Main Loader Container */}
      <div className="relative flex flex-col items-center text-center px-4">
        {/* Animated Emblem / Logo Wrapper */}
        <div className="relative mb-6 flex items-center justify-center">
          {/* Outer Golden Spinner Ring */}
          <div className="w-24 h-24 sm:w-28 sm:h-28 rounded-full border-2 border-[#c39b5b]/30 border-t-[#842343] border-r-[#c39b5b] animate-spin" />

          {/* Logo inside */}
          <div className="absolute w-14 h-14 sm:w-16 sm:h-16 rounded-full bg-white shadow-md p-2 flex items-center justify-center animate-bounce-subtle">
            <img
              src={logo}
              alt="CSI Diocese of Malabar Logo"
              className="w-full h-full object-contain"
            />
          </div>
        </div>

        {/* Title */}
        <h2 className="font-serif text-[#1a1715] text-xl sm:text-2xl font-bold tracking-wide mb-1">
          CSI DIOCESE OF MALABAR
        </h2>
        <p className="text-[#842343] text-xs sm:text-sm font-sans font-medium tracking-widest uppercase mb-6">
          Church of South India
        </p>

        {/* Progress Bar Container */}
        <div className="w-48 h-1 bg-[#c39b5b]/20 rounded-full overflow-hidden relative">
          <div className="h-full bg-gradient-to-r from-[#842343] via-[#c39b5b] to-[#842343] rounded-full animate-loader-bar" />
        </div>
      </div>
    </div>
  );
}
